// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navbar_wrapper__26t3z","btn":"Navbar_btn__2-XNB","MuiBox-root-2":"Navbar_MuiBox-root-2__XXM9O"};